export default "__VITE_ASSET__0vBsEUBo__"